module.exports = __webpack_public_path__ + "static/media/image (26).6589f06b.jpg";